var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext, useEffect } from 'react';
import SearchApiService from '../../../../Search/services/SearchApiService';
import LogApiService from '../../../../Shared/services/LogApiService';
import Alert, { AlertType } from '../../../../Shared/components/Alert';
import { UnitContext } from '../../../context/UnitContext';
import Filters from './Filters';
import { useQueryParams } from 'use-query-params';
import { JsonUrlParam } from '../../../../Shared/useQueryParams/paramTypes/JsonUrlParam';
import { RootContext } from '../../../../Context/RootContext';
import ViewControl from './ViewControl';
import View from './View';
const Listings = () => {
    const { state, dispatch } = useContext(UnitContext);
    const { pageContext: pageSettings, pluginContext: pluginSettings } = useContext(RootContext);
    const [query, setQuery] = useQueryParams({
        userFilter: JsonUrlParam,
        groupFilter: JsonUrlParam,
        view: JsonUrlParam,
        page: JsonUrlParam,
        sorting: JsonUrlParam,
    });
    const userFilters = state.filters[state.currentFilterGroup].userFilters;
    const handleDefaultSorting = () => {
        if (state.sorting.field)
            return;
        const sortingOptions = {
            complex: { direction: 'asc', field: 'fields.name' },
            property: { direction: 'asc', field: 'fields.street' },
            default: { direction: 'desc', field: 'fields.crdate' },
        };
        const sortingValue = sortingOptions[state.currentFilterGroup] || sortingOptions.default;
        dispatch({ type: 'changeSorting', value: sortingValue });
    };
    const handleQueryFilters = () => {
        if (query.groupFilter) {
            dispatch({ type: query.userFilter ? 'handleQueryFilters' : 'changeGroupFilter', value: query });
        }
        else {
            setInitialGroupFilter();
        }
    };
    const setInitialGroupFilter = () => {
        let initialGroupFilter = {
            key: state.currentFilterGroup,
        };
        pluginSettings.filters[state.currentFilterGroup].filters.forEach((filter) => {
            initialGroupFilter[filter.filterQuery] = filter.filterValue;
        });
        dispatch({ type: 'changeGroupFilter', value: { groupFilter: initialGroupFilter } });
    };
    const getUnits = () => __awaiter(void 0, void 0, void 0, function* () {
        setQuery({
            groupFilter: state.chosenGroupFilters,
            userFilter: state.chosenUserFilters,
            view: state.currentView,
            page: state.currentPage,
            sorting: state.sorting,
        }, 'push');
        try {
            const filtersToBypass = getFiltersToBypass();
            const searchResponse = yield getSearchResponse(buildQuery(), filtersToBypass);
            if (!searchResponse.facets) {
                dispatch({ type: 'setError' });
            }
            else {
                dispatch({ type: 'setData', value: searchResponse });
            }
        }
        catch (error) {
            handleError(error);
        }
    });
    const buildQuery = () => {
        let query = Object.assign(Object.assign({}, state.chosenGroupFilters), state.chosenUserFilters);
        if (state.currentView === 'map') {
            return Object.assign(Object.assign({}, query), { with_location: true, size: 20000 });
        }
        else {
            let updatedQuery = Object.assign(Object.assign({}, query), { from: (state.currentPage - 1) * pluginSettings.itemsPerPage, size: pluginSettings.itemsPerPage });
            if (state.sorting.field) {
                updatedQuery.sort = state.sorting;
            }
            return updatedQuery;
        }
    };
    const getFiltersToBypass = () => {
        return userFilters
            .filter((userFilter) => userFilter.type === 'checkbox')
            .map((userFilter) => userFilter.field || null);
    };
    const getSearchResponse = (query, filtersToBypass) => {
        return SearchApiService.searchWithFacets(query, state.currentFilterGroup === 'complex' ? 'complex' : 'unit', pageSettings.languagePath, filtersToBypass);
    };
    const handleError = (error) => {
        if (error instanceof Error) {
            LogApiService.error(error, pageSettings.marathonAppId);
        }
        dispatch({ type: 'setError' });
    };
    useEffect(() => {
        handleQueryFilters();
        handleDefaultSorting();
    }, []);
    useEffect(() => {
        if (!state.reloadNeeded) {
            return;
        }
        dispatch({ type: 'setLoading' });
        getUnits();
    }, [state.reloadNeeded]);
    if (state.error) {
        return (React.createElement("div", { className: "zds-row" },
            React.createElement(Alert, { title: "t(unknownError)", type: AlertType.error })));
    }
    return (React.createElement("div", { className: "zds-row" },
        state.currentView !== 'map' && (React.createElement(React.Fragment, null,
            pluginSettings.title && (React.createElement("div", { className: "zds-margin-bottom-6" },
                React.createElement("h1", { className: "zds-headline-xxl" }, pluginSettings.title))),
            pluginSettings.content && (React.createElement("div", { className: "zds-row zds-margin-bottom-6" },
                React.createElement("div", { dangerouslySetInnerHTML: { __html: pluginSettings.content } }))))),
        userFilters.length !== 0 && (React.createElement("div", { className: state.currentView !== 'map'
                ? 'lg:zds-col-3 md:zds-col-4'
                : 'zds-col-12 real-estate__map-filter md:zds-padding-x-12' },
            React.createElement(Filters, null))),
        React.createElement("div", { className: state.currentView == 'map'
                ? 'zds-col md:zds-padding-x-0'
                : userFilters.length
                    ? 'lg:zds-offset-1 md:zds-col-8'
                    : 'md:zds-col-12' },
            React.createElement(ViewControl, null),
            React.createElement(View, null))));
};
export default Listings;
